import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { ROLES } from "types/user";
import { getAmericanDateTime } from "utils/Datetime";
import { UserWithPet } from "components/VetStore/CoachPetAvatar";

type CommentBoxProps = {
  comment: any;
};

export const CommentBox: FC<CommentBoxProps> = ({ comment }) => {
  return (
    <Box py={2} px={1}>
      <Stack direction="row" spacing={2} alignItems="center">
        <UserWithPet
          pictureUrl={comment.user?.picture_url}
          name={comment.user?.name}
          equippedStoreItems={comment.user?.equipped_store_items}
          avatarSize={40}
        />
        <Box>
          <Stack direction="row" spacing={1} alignItems={"center"}>
            <Box>
              {comment.user.name}{" "}
              <Typography variant="body2" color="secondary" component={"span"}>
                ({comment.user.role === ROLES.STUDENT && "Learner"}
                {comment.user.role === ROLES.COACH && "Coach"}
                {comment.user.role === ROLES.MANAGER && "Manager"}
                {comment.user.role === ROLES.DIRECTOR && "Director"}
                {comment.user.role === ROLES.ADMIN && "Admin"})
              </Typography>
            </Box>
          </Stack>
          <Typography variant="body2" color="secondary">
            {getAmericanDateTime(comment.created_at)}
          </Typography>
        </Box>
      </Stack>
      <Box mt={2}>{comment.text}</Box>
    </Box>
  );
};
